import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  SelectedBatch: [],
  SelectedShifts: [],
};

export const BatchReducer = createSlice({
  name: 'BatchReducer',
  initialState,
  reducers: {
    setSelectedBatch: (state, action) => {
      state.SelectedBatch = action.payload;
    },
    setSelectedShifts: (state, action) => {
      state.SelectedShifts = action.payload;
    },
  },
});

export const { setSelectedBatch, setSelectedShifts } = BatchReducer.actions;

export default BatchReducer.reducer;
